/* ==========================================================================
   SearcherFli > Client > Store > Actions
   ========================================================================== */

/* Types */
const DESTROY = 'SEARCHERFLI::DESTROY';

const CHANGE_ORIGIN = 'SEARCHERFLI::CHANGE_ORIGIN';

const CHANGE_DESTINATION = 'SEARCHERFLI::CHANGE_DESTINATION';

const CHANGE_CALENDAR = 'SEARCHERFLI::CHANGE_CALENDAR';

const CHANGE_PASSENGERS = 'SEARCHERFLI::CHANGE_PASSENGERS';

const CHANGE_PRODUCT = 'SEARCHERFLI::CHANGE_PRODUCT';

const CHANGE_CLASSES = 'SEARCHERFLI::CHANGE_CLASSES';

const CHANGE_DISCOUNT = 'SEARCHERFLI::CHANGE_DISCOUNT';

const CHANGE_AIRLINES = 'SEARCHERFLI::CHANGE_AIRLINES';

const CHANGE_OPTIONS = 'SEARCHERFLI::CHANGE_OPTIONS';

const SET_SEARCHER = 'SEARCHERFLI::SET_SEARCHER';

const CHANGE_CROSSSELLING = 'SEARCHERFLI::CHANGE_CROSSSELLING';

const ADD_PAXES_NAMES = 'SEARCHERFLI::ADD_PAXES_NAMES';

const ADD_TRAVEL_POLICY = 'SEARCHERFLI::ADD_TRAVEL_POLICY';

const ADD_DIRECT_FLIGHTS = 'SEARCHERFLI::ADD_DIRECT_FLIGHTS';

/* Openjaw */
const CHANGE_ROW = 'SEARCHERFLI::CHANGE_ROW';
const SET_ROW = 'SEARCHERFLI::SET_ROW';
const REMOVE_ROW = 'SEARCHERFLI::REMOVE_ROW';

/* Actions */
const destroy = () => ({ type: DESTROY });

const changeOrigin = payload => ({ type: CHANGE_ORIGIN, payload });

const changeDestination = payload => ({ type: CHANGE_DESTINATION, payload });

const changeCalendar = payload => ({ type: CHANGE_CALENDAR, payload });

const changePassengers = payload => ({ type: CHANGE_PASSENGERS, payload });

const changeProduct = payload => ({ type: CHANGE_PRODUCT, payload });

const changeClasses = payload => ({ type: CHANGE_CLASSES, payload });

const changeDiscount = payload => ({ type: CHANGE_DISCOUNT, payload });

const changeAirlines = payload => ({ type: CHANGE_AIRLINES, payload });

const changeOptions = payload => ({ type: CHANGE_OPTIONS, payload });

const setSearcher = payload => ({ type: SET_SEARCHER, payload });

const changeCrossSelling = payload => ({ type: CHANGE_CROSSSELLING, payload });

const addPaxesNames = payload => ({ type: ADD_PAXES_NAMES, payload });

const addTravelPolicy = payload => ({ type: ADD_TRAVEL_POLICY, payload });

const addDirectFlights = payload => ({ type: ADD_DIRECT_FLIGHTS, payload });

/* Openjaw */
const changeRow = payload => ({ type: CHANGE_ROW, payload });
const setRow = payload => ({ type: SET_ROW, payload });
const removeRow = payload => ({ type: REMOVE_ROW, payload });
/* Exports */
module.exports = {
    types: {
        DESTROY,
        CHANGE_ORIGIN,
        CHANGE_DESTINATION,
        CHANGE_CALENDAR,
        CHANGE_PASSENGERS,
        CHANGE_PRODUCT,
        CHANGE_CLASSES,
        CHANGE_DISCOUNT,
        CHANGE_AIRLINES,
        CHANGE_OPTIONS,
        SET_SEARCHER,
        CHANGE_CROSSSELLING,
        ADD_PAXES_NAMES,
        ADD_TRAVEL_POLICY,
        ADD_DIRECT_FLIGHTS,
        /* Openjaw types */
        CHANGE_ROW,
        SET_ROW,
        REMOVE_ROW
    },
    actions: {
        destroy,
        changeOrigin,
        changeDestination,
        changeCalendar,
        changePassengers,
        changeProduct,
        changeClasses,
        changeDiscount,
        changeAirlines,
        changeOptions,
        setSearcher,
        changeCrossSelling,
        addPaxesNames,
        addDirectFlights,
        /* Openjaw actions */
        changeRow,
        setRow,
        removeRow,
        addTravelPolicy
    }
};
